// extracted by mini-css-extract-plugin
export default {"fixed_menu":"style_fixed_menu__iEJjG"};